import { Box } from '@lyearn/ui';

import { BodyRendererProps } from '../../types';

function BodyRenderer(props: BodyRendererProps) {
  const { sectionIndex, section, children, ...rest } = props;
  return (
    <Box className="w-full pb-28" {...rest}>
      {children}
    </Box>
  );
}

export default BodyRenderer;
